import { ContentType } from '@insided/shared/utils/contentType'

/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import OpenEscalationOptions from '../../Escalation/OpenEscalationOptions'
import Quote from '../Quote'
import { Author } from '../../interfaces'
import { ConfigContext } from '../../utils'

export interface ReplyContentActionsProps {
  author: Author
  content: string
  topicId: number
  id: string
  contentType: ContentType
  trashed: boolean
  isPinned: boolean
  likedByOpener: boolean
  likedBy: string[]
  handleTogglePin: () => void
  handleToggleLike: () => void
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
}

const ReplyContentActions = ({ author, content, contentType, isPinned, id, trashed, handleTogglePin, handleToggleLike, likedByOpener, likedBy, isProductboardNoteCreationEnabled, isSalesforceCaseEscalationEnabled, isZendeskTicketEscalationEnabled, isFreshdeskTicketEscalationEnabled }: ReplyContentActionsProps) => {
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig }) => {
        return (
          <footer className='post--options-list'>
            <OpenEscalationOptions
              isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
              isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
              isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
              isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
              trashed={trashed}
              topicId={parseInt(id)}
              contentType={contentType}
              isReply
            />
            {!trashed &&
              <div className='post--options-list-container'>
                {contentTypeConfig.pinReply &&
                  <div className='post--options-list-container-item'>
                    <a data-qa='pin-reply' className='post--options-icon' onClick={handleTogglePin}>
                      <Icon icon='pin' width={16} height={16} />
                      {isPinned ? 'Unpin reply' : 'Pin reply'}
                    </a></div>}
                <div className='post--options-list-container-item'>
                  <a data-qa='like-reply' className={likedByOpener ? 'active' : ''} onClick={handleToggleLike}>
                    <i className='fa fa-thumbs-up' /> Like ({likedBy.length})
                  </a>
                </div>
                <Quote data-qa='quote-reply' content={content} author={author} />
              </div>}
          </footer>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default ReplyContentActions
